export type AsyncPoolResult<T> = {
  successful: T[]
  failed: { item: T; error: unknown }[]
}

export const asyncPool = async <T, R>(
  items: T[],
  worker: (_item: T) => Promise<R>,
  concurrency: number = 3
): Promise<AsyncPoolResult<T>> => {
  const successful: T[] = []
  const failed: { item: T; error: unknown }[] = []
  const inFlight = new Set<Promise<void>>()
  const limit = Math.max(1, concurrency)

  const run = async (item: T) => {
    try {
      await worker(item)
      successful.push(item)
    } catch (error) {
      failed.push({ item, error })
    }
  }

  for (const item of items) {
    const task = run(item).finally(() => {
      inFlight.delete(task)
    })

    inFlight.add(task)

    if (inFlight.size >= limit) {
      await Promise.race(inFlight)
    }
  }

  await Promise.all(inFlight)

  return { successful, failed }
}
